import { AxiosResponse } from 'axios';

export interface ErrorResponse {
  code: number
}

export function isErrorResponse(data: object | ErrorResponse): data is ErrorResponse {
  return (data as ErrorResponse).code !== undefined;
}

export interface FieldError {
  field: string;
  code: string;
  defaultMessage: string;
}

export interface ValidationErrors {
  fieldErrors: FieldError[];
}

export interface ValidationErrorResponse extends AxiosResponse {
  data: ValidationErrors;
}

export function isValidationErrorResponse(response: AxiosResponse): response is ValidationErrorResponse {
  return response !== undefined && response.status === 422;
}

export function isValidationErrors(data: object | ValidationErrors): data is ValidationErrors {
  return (data as ValidationErrors).fieldErrors !== undefined;
}

export function emptyValidationErrors(): ValidationErrors {
  return {
    fieldErrors: [],
  };
}
